import { createFileRoute } from "@tanstack/react-router";

import { faqJsonLd } from "../components/tools/tool-layout";
import { WEEKS_COPY, WeeksView } from "../components/tools/weeks";
import { seo } from "../lib/head";

export const Route = createFileRoute("/grossesse-semaine-par-semaine")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "La grossesse semaine par semaine : taille et poids de bébé · Listou",
      description:
        "De 5 à 41 SA, la taille de bébé comparée à un fruit, son poids et les étapes de son développement, semaine après semaine.",
      jsonLd: faqJsonLd(WEEKS_COPY.faq),
    }),
  component: WeeksView,
});
